
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface Product {
  id: string;
  name?: string;
  title?: string;
  price_cents?: number;
  amount?: number;
  billing_period?: string;
  status?: string;
  user_id?: string;
}

interface ProcessedProduct {
  product_id: string;
  sort_order?: number;
  details?: Product | null;
  isSubscription: boolean;
}

interface UseOfferProductProcessingProps {
  isOpen: boolean;
  products?: Product[];
  connectedAccountId?: string | null;
}

export const useOfferProductProcessing = ({ 
  isOpen, 
  products = [],
  connectedAccountId 
}: UseOfferProductProcessingProps) => {
  const [processedProducts, setProcessedProducts] = useState<ProcessedProduct[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!isOpen || !products || products.length === 0) {
      setProcessedProducts([]);
      return;
    }

    setIsLoading(true);
    console.log("Processing products:", products);

    const processed = products.map((product) => ({
      product_id: product.id,
      sort_order: 0,
      details: product,
      isSubscription: product.billing_period !== 'one_time' && product.billing_period !== undefined
    }));

    console.log("Processed products:", processed);
    setProcessedProducts(processed);
    setIsLoading(false);
  }, [isOpen, products, connectedAccountId]);

  return {
    processedProducts,
    isLoading
  };
};
